AFRAME.registerComponent('rounded-box', {
    schema: {
        width: { type: 'number', default: 1 },
        height: { type: 'number', default: 1 },
        depth: { type: 'number', default: 1 },
        radius: { type: 'number', default: 0.1 },
        color: { type: 'color', default: '#ffffff' },
        opacity: { type: 'number', default: 1.0, min: 0, max: 1 },
        cornerstyle: { type: 'string', default: 'ext', oneOf: ['ext', '3d'] }
    },

    init: function () {
        this.updateGeometry();
    },

    update: function (oldData) {
        const data = this.data;
        const mesh = this.el.getObject3D('mesh');
        if (!mesh) return;

        if (
            oldData.width !== data.width ||
            oldData.height !== data.height ||
            oldData.depth !== data.depth ||
            oldData.radius !== data.radius ||
            oldData.cornerstyle !== data.cornerstyle
        ) {
            this.updateGeometry();
        }

        if (oldData.color !== data.color || oldData.opacity !== data.opacity) {
            mesh.material.color.set(data.color);
            mesh.material.opacity = data.opacity;
            mesh.material.transparent = data.opacity < 1;
            mesh.material.needsUpdate = true;
        }
    },

    updateGeometry: function () {
        const data = this.data;
        const shape = new THREE.Shape();

        const halfWidth = data.width / 2;
        const halfHeight = data.height / 2;
        const radius = Math.min(data.radius, Math.min(data.width, data.height) / 2);

        shape.moveTo(-halfWidth, -halfHeight + radius);
        shape.lineTo(-halfWidth, halfHeight - radius);
        shape.arc(radius, 0, radius, Math.PI, Math.PI / 2, true);
        shape.lineTo(halfWidth - radius, halfHeight);
        shape.arc(0, -radius, radius, Math.PI / 2, 0, true);
        shape.lineTo(halfWidth, -halfHeight + radius);
        shape.arc(-radius, 0, radius, 0, -Math.PI / 2, true);
        shape.lineTo(-halfWidth + radius, -halfHeight);
        shape.arc(0, radius, radius, -Math.PI / 2, Math.PI, true);
        shape.closePath();

        const extrudeSettings = {
            depth: data.depth,
            bevelEnabled: data.cornerstyle === '3d',
            bevelThickness: data.cornerstyle === '3d' ? radius / 2 : 0,
            bevelSize: data.cornerstyle === '3d' ? radius / 2 : 0,
            bevelSegments: data.cornerstyle === '3d' ? 8 : 0
        };
        const geometry = new THREE.ExtrudeGeometry(shape, extrudeSettings);
        geometry.translate(0, 0, -data.depth / 2);

        const material = new THREE.MeshPhongMaterial({
            color: data.color,
            opacity: data.opacity,
            transparent: data.opacity < 1,
            side: THREE.DoubleSide,
            shininess: 30
        });

        const existingMesh = this.el.getObject3D('mesh');
        if (existingMesh) {
            existingMesh.geometry.dispose();
            existingMesh.geometry = geometry;
        } else {
            const mesh = new THREE.Mesh(geometry, material);
            this.el.setObject3D('mesh', mesh);
        }
    },

    remove: function () {
        const mesh = this.el.getObject3D('mesh');
        if (mesh) {
            mesh.geometry.dispose();
            mesh.material.dispose();
            this.el.removeObject3D('mesh');
        }
    }
});

AFRAME.registerPrimitive('a-rounded-box', {
    defaultComponents: {
        'rounded-box': {}
    },
    mappings: {
        width: 'rounded-box.width',
        height: 'rounded-box.height',
        depth: 'rounded-box.depth',
        radius: 'rounded-box.radius',
        color: 'rounded-box.color',
        opacity: 'rounded-box.opacity',
        cornerstyle: 'rounded-box.cornerstyle'
    }
});